<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <div class="z-card z-card--only-desktop">
            <z-icon
              :icon="['far', 'check-circle']"
              color="success"
              size="large"
              class="success-icon"
            />
            <div class="z-title z-title--small spacer-bottom-l">
              Seus dados foram alterados com sucesso
            </div>

            <div class="z-text z-text--medium  spacer-bottom-l">
              Caso seu email tenha sido alterado nós enviaremos um email de confirmação para o novo email,
              após a confirmação do novo email iremos prosseguir com a alteração.
            </div>

            <router-link
              tag="button"
              :to="{ name: 'panel'}"
              class="z-button z-button--primary z-button--block"
            >
              Voltar para página inicial
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.success-icon {
  margin-bottom: var(--space-medium);
}

.z-card--only-desktop {
  @media (max-width: $screen-sm-max) {
    background-color: unset;
    box-shadow: unset;
    padding: unset;
    transition: unset;
  }
}
</style>

<script>

export default {
  mounted() {
    this.$tracker.logEvent('Viewed Profile Confirmation Page');
  },
};
</script>
